var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import ReclameAquiAverageMonthlyComplaints from '@/modules/search/components/filterPanels/ComplaintsPanel/ReclameAquiAverageMonthlyComplaints.vue';
import { connect } from '@/overmind';
import { json } from 'overmind';
let ReclameAquiAverageMonthlyComplaintsContainer = class ReclameAquiAverageMonthlyComplaintsContainer extends Vue {
    constructor() {
        super(...arguments);
        // @ts-ignore
        this.values = json(this.inputValues);
    }
    onValuesChanged(newVal) {
        this.values = newVal;
        // @ts-ignore
        this.actionsSearch.searches.buildPotentialResults();
        // @ts-ignore
        this.setInputRangeReclameAquiAverageComplaintsMonthly(newVal);
    }
};
__decorate([
    Prop({ default: () => { } })
], ReclameAquiAverageMonthlyComplaintsContainer.prototype, "filter", void 0);
ReclameAquiAverageMonthlyComplaintsContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        selected: state.totalSelected.complaints.reclameAquiAverageComplaintsMonthly,
        inputValues: state.selectedInputRange['reclamacoes_reclame_aqui.media_mensal_reclamacoes'],
        setInputRangeReclameAquiAverageComplaintsMonthly: actions.filters.setInputRangeReclameAquiAverageComplaintsMonthly,
        actions: actions.filters,
        actionsSearch: actions.search,
    }), {
        components: { ReclameAquiAverageMonthlyComplaints },
    }))
], ReclameAquiAverageMonthlyComplaintsContainer);
export default ReclameAquiAverageMonthlyComplaintsContainer;
